module.exports = "/images/msg-success.svg?92a37f7dc6b019025ad4453162d1acab";